import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';

const imgKV = {
    pc: 'https://websiteoss.ecoflow.com/upload/image/1775283512482/KV.jpg',
    h5: 'https://websiteoss.ecoflow.com/upload/image/1775283512653/M_KV.jpg',
};

const youtubeEmbed = 'https://websiteoss.ecoflow.com/upload/video/1775030738344/DELTA%203.mp4';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { pageStatus } = useProductStore();

    const statusA = pageStatus === 'statusA';
    const configs = {
        label: t.rich('A_label', {
            sup: (tx: string) => <sup className="sup">{tx}</sup>
        }),
        title: t('A_title'),
        desc: t('A_desc'),
        pc: imgKV.pc,
        h5: imgKV.h5,
        pad: imgKV.h5,
        btn_text: statusA ? '' : t('A_btn'),
        btn_link: youtubeEmbed,
    };

    return (
        <div className={`${styles.TheComp} GtmModuleData-section`} data-section-id="D3-A" id='D3-A'>
            <EfBanner {...configs} />
        </div>
    );
}
